<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="From"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }"
                                        format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']"
                                        style="width:100%" />
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites"
                                        optionFilterProp="children" style="width: 100%" :filterOption="filterOption"
                                        :disabled="site_type != 'ho'">
                                        <a-select-option v-for="option in siteOptions" :key="option.id"
                                            :value="option.id">{{ option.name }}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Terminal">
                                    <a-select v-model="inputTerminal" showSearch placeholder="All Terminals"
                                        optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in terminalOptions" :key="option.id"
                                            :value="option.id">{{ option.name }}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                                <vue-json-to-csv v-if="JsonData.length > 0" :show-labels="false" :json-data="JsonData"
                                    :csv-title="currentProfile.replace(/_/g, '-') + '-' + currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right"
                                        style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button>
                                    &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <download-excel v-if="JsonData.length > 0" :fields="fields_export" :data="JsonData"
                                    :name="currentProfile.replace(/_/g, '-') + '-' + currDate.replace(/ /g, '') + `.xls`"
                                    class="float-right" style=" width: 20%;">
                                    <button class="btn btn-sm btn-success"
                                        style="border-radius: 24px; border:0px; width: 100%;"
                                        @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                                </download-excel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage';
import moment from 'moment';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import VueJsonToCsv from 'vue-json-to-csv';
import reportUtils from '../../components/reportUtils'

import {
    mapState
} from 'vuex'

export default {
    data() {
        return {
            spinning: false,
            inputDate: [moment().startOf('day'), moment().endOf('day')],
            currDate: moment().format("L_LT").split(":").join(";"),
            inputSite: [],
            inputTerminal: 0,
            site_type: "ho",
            siteOptions: [],
            terminalOptions: [],
            allTerminals: [],
            cashierOptions: [],
            birSalesReports: [],
            JsonData: [],
            payment_types: [],
            transactionTypes: [],
            subSegments: [],
            collectionTypes: [],
            reasonTypesWithFinancial: [],
            // defaultTransactionTypes: ['DINEIN', 'TAKEOUT', 'DELIVERY'],
            fields_export: { // this is to empty the header / first row and assign the 0 - 3 as array key 
                ' ': '0',
                '  ': '1',
                '   ': '2',
                '    ': '3',
                '     ': '4'
            }
        }
    },
    watch: {
        inputSite(newSiteIds) {
            this.updateTerminaOptions(newSiteIds)
        },
    },
    mounted: async function () {
        var component_x = this;

        var userId = secureStorage.getItem("userId")
        var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
        component_x.siteOptions = sites;
        component_x.sort(component_x.siteOptions);

        let siteId = secureStorage.getItem("defaultSiteId")
        this.inputSite = [siteId]

        let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
        if (site != undefined) {
            this.site_type = site.site_type
        }
        this.getPosTransactionTypes()
        this.getCollectionTypes();
        this.getSubSegments();
        this.getReasonTypesIncludedOnFinancialReport();
        this.getPaymentTypes();

        let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
        component_x.terminalOptions = terminals;
        component_x.terminalOptions.push({ id: 0, name: ' All Terminals' })
        // component_x.sort(component_x.terminalOptions);
        component_x.terminalOptions = this.terminalOptions.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });

    },
    computed: {
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
    },
    components: {
        VueJsonToCsv
    },
    methods: {
        moment,
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data) {
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        async updateTerminaOptions(siteId) {
            let terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
            this.terminalOptions = terminals;
            this.terminalOptions.push({ id: 0, name: ' All Terminals' })
            // component_x.sort(component_x.terminalOptions);
            this.terminalOptions = this.terminalOptions.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        convertToCurrency(num) {
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        convertTextToStrong(data) {
            return `<strong>${data}</strong>`
        },
        formatEmpltyCell(data) {
            return `<center>${data}</center>`
        },
        openNotificationWithIcon(type, msg) {
            this.$notification[type]({
                message: 'Export Error',
                description: msg
            });
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        async getPaymentTypes() {
            var component_x = this;
            this.spinning = true;
            // let payment_types_data = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_distinct_payment_types_on_pos_document_payments", null, "BXI-File");
            let payment_types_data = await HTTPRequest.getRequest(component_x.endPoint + "payment_types/get_valid_payment_types", null);
            let all_payment_types = payment_types_data
            this.sort(all_payment_types)
            this.payment_types = all_payment_types.map(paymentType => ({
                ...paymentType,
                sanitized_name: this.sanitizePaymentTypeName(paymentType.code),
                name: paymentType.name.toUpperCase()
            }));
            this.spinning = false;
        },
        async getPosTransactionTypes() {
            let transaction_type_data = await HTTPRequest.getRequest(this.endPoint + "pos_transaction_types/get_valid_pos_transaction_types", null);
            let all_transaction_types = transaction_type_data
            this.sort(all_transaction_types)
            this.transactionTypes = all_transaction_types
                // .filter(item => this.defaultTransactionTypes.includes(item.code))
                .map(item =>
                ({
                    id: item.id,
                    name: item.name.toUpperCase(),
                    sanitized_name: this.sanitizePaymentTypeName(item.code)
                })
                );
        },
        async getSubSegments() {
            let sub_segment_data = await HTTPRequest.getRequest(this.endPoint + "pos_sub_segments/get_valid_pos_sub_segments", null);
            let all_sub_segment = sub_segment_data
            this.sort(all_sub_segment)
            this.subSegments = all_sub_segment
                .map(item =>
                ({
                    id: item.id,
                    pos_trans_id: item.pos_transaction_type_id,
                    name: item.name.toUpperCase(),
                    sanitized_name: this.sanitizePaymentTypeName(item.name)
                })
                );
        },
        async getCollectionTypes() {
            let collection_types_data = await HTTPRequest.getRequest(this.endPoint + "collection_types/get_valid_collection_types", null);
            let all_collection_types = collection_types_data
            this.sort(all_collection_types)
            this.collectionTypes = all_collection_types
                .map(item =>
                ({
                    name: item.name.toUpperCase(),
                    sanitized_name: this.sanitizePaymentTypeName(item.code)
                })
                );
        },
        async getReasonTypesIncludedOnFinancialReport() {
            let reason_type_on_financial = await HTTPRequest.getRequest(this.endPoint + "reason_types/get_reason_types_included_on_financial_report", null);
            let all_reason_type_on_financial = reason_type_on_financial
            this.sort(all_reason_type_on_financial)
            this.reasonTypesWithFinancial = all_reason_type_on_financial
                .map(item =>
                ({
                    id: item.id,
                    name: item.name.toUpperCase(),
                    sanitized_name: this.sanitizePaymentTypeName(item.name)
                })
                );
        },
        sanitizePaymentTypeName(name) {
            return name
                .replace(/[^a-zA-Z0-9\s\/-]/g, '')
                .replace(/\s/g, '_')
                .replace(/[\/-]+/g, '_')
                .replace(/_+/g, '_')
                .toLowerCase();
        },
        generateReport: async function () {
            // pdf
            this.spinning = true;
            let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
            let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
            let report_from_date = this.inputDate[0].format('YYYY-MM-DD');
            let report_to_date = this.inputDate[1].format('YYYY-MM-DD');

            var get_request = await HTTPRequest.getRequest(this.endPoint + 'financial_reports?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal, null, "BXI-File");

            if (this.inputDate.length == 0) {
                this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                return
            }
            let reportLogo = document.getElementById('reportLogo');

            var siteSpecific = get_request;
            if (siteSpecific.length > 0) {

                if (siteSpecific[0].report_details[0].site_name == null) {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning = false;
                    return
                }

                let doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'b3' });

                for (var x = 0; x < siteSpecific.length; x++) {
                    doc.addImage(reportLogo, "PNG", 10, 5, 15, 15);

                    doc.setFontSize(14);
                    doc.setFontType("bold");

                    let design_y = 20
                    design_y = design_y + 5;
                    doc.text(15, design_y, `Financial Report`)
                    doc.setFontType("normal");
                    doc.setFontSize(12);

                    // design_y = design_y + 5;
                    // doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                    if (x > 0) {
                        //add new page
                        doc.addPage();
                    }

                    design_y = design_y + 5;
                    doc.setFontSize(10)
                    doc.text(15, design_y, "Store Name: " + siteSpecific[x].report_details[0].site_name)
                    // design_y = design_y + 5;
                    // doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_name)

                    // start
                    this.birSalesReports = siteSpecific[x].report_details

                    let detailColStyles = {
                        0: { cellWidth: 60 },
                        1: { cellWidth: 25 },
                        2: { cellWidth: 20 },
                        3: { cellWidth: 30 },
                    }

                    let header = [
                        { content: '', styles: { halign: 'center' } },
                        { content: '', styles: { halign: 'center' } },
                        { content: '', styles: { halign: 'center' } },
                        { content: '', styles: { halign: 'center' } },
                    ]

                    if (this.birSalesReports.length > 0) {
                        let reportData = []

                        for (let i = 0; i < this.birSalesReports.length; i++) {
                            let reportLine = this.birSalesReports[i]

                            // let report_separator = [{content:'-------------------------------------------------', styles: { halign: 'left'}}]
                            // let report_separator_end = [{content:'', styles: { halign: 'left'}}, '','---------------------------']
                            let report_running_totals_to_date = [{ content: 'RUNNING TOTALS TO DATE', styles: { fontStyle: 'bold', halign: 'left', cellPadding: { top: 3.5, right: 1, bottom: 3.5, left: 1 } } }, '', '', '']
                            let report_totals = [{ content: 'REPORT TOTALS', styles: { fontStyle: 'bold', halign: 'left', cellPadding: { top: 3.5, right: 1, bottom: 3.5, left: 1 } } }, '', '', '']
                            let report_date_from = [{ content: 'Report Date: ', styles: { halign: 'left' } }, { content: `${report_from_date}`, styles: { halign: 'left' } }, '', '']
                            let report_date_to = [{ content: '', styles: { halign: 'left' } }, { content: `${report_to_date}`, styles: { halign: 'left', cellPadding: { top: 1, right: 1, bottom: 3, left: 1 } } }, '', '']

                            // details for running totals from live to date 
                            let report_from_live_gross = [{ content: 'GROSS', styles: { halign: 'left', cellPadding: { top: 2, right: 1, bottom: 1, left: 1 } } }, '', '', { content: this.convertToCurrency(Number(reportLine.running_gross)), styles: { cellPadding: { top: 2, right: 1, bottom: 1, left: 1 } } }]
                            let report_from_live_less_discount = [{ content: 'LESS DISCOUNT', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.running_less_discount))]
                            let report_from_live_vat_exempt = [{ content: '12% VAT-EXEMPT', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.running_vat_exempt))]
                            let report_from_live_gross_less_discount = [{ content: 'GROSS LESS DEDUCTIONS', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.running_gross_less_discount))]
                            let report_from_live_net = [{ content: 'NET', styles: { halign: 'left', cellPadding: { top: 1, right: 1, bottom: 3, left: 1 } } }, '', '', this.convertToCurrency(Number(reportLine.running_net))]
                            let report_from_live_vat = [{ content: '12% VAT', styles: { halign: 'left', cellPadding: { top: 1, right: 1, bottom: 3, left: 1 } } }, '', '', this.convertToCurrency(Number(reportLine.running_vat))]

                                // details for report totals
                                let report_gross = [{content:'GROSS', styles: { halign: 'left', cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}},'', '',  {content: this.convertToCurrency(Number(reportLine.report_gross)), styles: {cellPadding: {top: 2, right: 1, bottom: 1, left: 1}}}]
                                let report_less_discount = [{content:'LESS DISCOUNT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_less_discount))]
                                let report_gross_less_discount = [{content:'GROSS LESS DEDUCTIONS', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_gross_less_discount))]
                                let report_net = [{content:'NET', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_net))]
                                let report_vat = [{content:'12% VAT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat))]
                                let report_vatable_sales = [{content:'NET VATABLE SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vatable_sales))]
                                let report_non_vatable_sales = [{content:'NET VAT-EXEMPT SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat_exempt_sales))]
                                let report_vat_exempt = [{content:'12% VAT-EXEMPT', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.report_vat_exempt))]

                            let report_count_amount = ['', '', { content: 'COUNT', styles: { fontStyle: 'bold' } }, { content: 'AMOUNT', styles: { fontStyle: 'bold' } }]

                            let report_collection_label = [{ content: 'COLLECTIONS', styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            let report_space = ['', '', '', '']

                            // details for segments/pos transaction types
                            let report_trans_types = [];
                            let report_sub_segments = [];
                            for (let t = 0; t < this.transactionTypes.length; t++) {
                                let trans_type = this.transactionTypes[t];
                                let trans_type_count = `${trans_type.sanitized_name}_count`;
                                let trans_type_amount = `${trans_type.sanitized_name}_amount`;

                                let currentReport = reportLine;
                                if (currentReport[trans_type_count] != null) {
                                    let report_trans_type = [
                                        { content: `${trans_type.name}`, styles: { halign: 'left' } }, '', currentReport[trans_type_count], this.convertToCurrency(Number(currentReport[trans_type_amount]))
                                    ];
                                    report_trans_types.push(report_trans_type);

                                    // ADD SUBSEGMENT BREAKDOWN ON TRANSACTION TYPES
                                    for (let s = 0; s < this.subSegments.length; s++) {

                                        let sub_segment = this.subSegments[s];
                                        let sub_segment_count = `${sub_segment.sanitized_name}_count`;
                                        let sub_segment_amount = `${sub_segment.sanitized_name}_amount`;

                                        // let no_sub_segment = this.transactionTypes[t];
                                        // let no_sub_segment_count = `no_${no_sub_segment.sanitized_name}_count`;
                                        // let no_sub_segment_amount = `no_${no_sub_segment.sanitized_name}_amount`;

                                        let currentReport = reportLine;
                                        if (currentReport[sub_segment_count] != null && currentReport[sub_segment_count] != '0') {
                                            let report_sub_segment = [
                                                { content: `  - ${sub_segment.name}`, styles: { halign: 'left' } }, '', currentReport[sub_segment_count], this.convertToCurrency(Number(currentReport[sub_segment_amount]))
                                            ];
                                            if (this.subSegments[s].pos_trans_id == this.transactionTypes[t].id) {
                                                report_trans_types.push(report_sub_segment)
                                            }
                                        }
                                        // add trans_type with no sub-segment 
                                        // if (currentReport[no_sub_segment_count] != null || currentReport[sub_segment_count] != '0') {
                                        //     let no_report_sub_segment = [
                                        //         {content: '  - NO SUB SEGMENT', styles: { halign: 'left'}}, '', currentReport[no_sub_segment_count], this.convertToCurrency(Number(currentReport[no_sub_segment_amount]))
                                        //     ];
                                        //     // add trans_type with no sub-segment once
                                        //     if(s == this.subSegments.length - 1){  
                                        //         report_trans_types.push(no_report_sub_segment)   
                                        //     }   
                                        // }
                                    } // end for(let  s = 0;  s < this.subSegments.length; s++) 
                                }
                            }

                            let report_aggregator_beverage = [{ content: 'BEVERAGE', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.beverage))]
                            let report_aggregator_food = [{ content: 'FOOD', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.food))]


                            // ADD REASON TYPES (e.g. ON US)
                            let report_reason_types = [];
                            for (let rt = 0; rt < this.reasonTypesWithFinancial.length; rt++) {
                                let reason_type = this.reasonTypesWithFinancial[rt];
                                let rt_count = `rt_${reason_type.sanitized_name}_count`;
                                let rt_amount = `rt_${reason_type.sanitized_name}_amount`;

                                let currentReport = reportLine;
                                if (currentReport[rt_count] != null) {
                                    if (currentReport[rt_count] != 0.0 || currentReport[rt_amount] != 0.0) {
                                        let report_reason_type = [{ content: `${reason_type.name} REASON`, styles: { halign: 'left' } }, '', currentReport[rt_count], this.convertToCurrency(Number(currentReport[rt_amount]))]
                                        report_reason_types.push(report_reason_type);
                                    }
                                }
                            }

                            let report_trans_count = [{ content: 'TRANSACTION COUNT', styles: { halign: 'left' } }, '', reportLine.transaction_count, '']
                            let report_guest_count = [{ content: 'GUEST COUNT', styles: { halign: 'left' } }, '', reportLine.guest_count, '']

                            // payment_types
                            let report_payments = [];
                            for (let p = 0; p < this.payment_types.length; p++) {
                                let payment_type = this.payment_types[p];
                                let payment_type_count = `${payment_type.sanitized_name}_count`;
                                let payment_type_amount = `${payment_type.sanitized_name}_amount`;
                                let currentReport = reportLine;

                                // Create a report for the current payment type
                                if (currentReport[payment_type_count] != null) {
                                    if (currentReport[payment_type_amount] != 0.0 || currentReport[payment_type_count] != 0) {
                                        // POS REQUIREMENT ONLY
                                        // if((payment_type.name == 'CASH') && (currentReport.cash_collection != null)){
                                        //     currentReport[payment_type_amount] = Number(currentReport[payment_type_amount]) + Number(currentReport.cash_collection)
                                        // }
                                        let report_payment = [
                                            { content: `${payment_type.name}`, styles: { halign: 'left' } }, '', currentReport[payment_type_count], this.convertToCurrency(Number(currentReport[payment_type_amount]))
                                        ];
                                        // Push the report into the accumulator array
                                        report_payments.push(report_payment);
                                    }
                                }


                            }

                            // collections
                            let report_collections = [];
                            let isCollectionPresent = false;
                            for (let p = 0; p < this.collectionTypes.length; p++) {
                                let collection_type = this.collectionTypes[p];
                                let collection_type_count = `${collection_type.sanitized_name}_count`;
                                let collection_type_amount = `${collection_type.sanitized_name}_amount`;

                                let currentReport = reportLine;

                                // Create a report for the current collection type
                                if (currentReport[collection_type_amount] != 0.0 || currentReport[collection_type_count] != 0) {
                                    isCollectionPresent = true;
                                    let report_collection = [
                                        { content: `${collection_type.name}`, styles: { halign: 'left' } }, '', currentReport[collection_type_count], this.convertToCurrency(Number(currentReport[collection_type_amount]))
                                    ];
                                    // Push the report into the accumulator array
                                    report_collections.push(report_collection);
                                } else {
                                    isCollectionPresent = false;
                                }
                            }

                            // EGC
                            let report_egc = []
                            if (reportLine.egc_count != 0 || reportLine.egc_amount != 0.0) {
                                report_egc = [{ content: 'EGC', styles: { halign: 'left' } }, '', reportLine.egc_count, reportLine.egc_amount]
                            }

                            // loyalty points
                            let report_award_count = [{ content: 'AWARD COUNT', styles: { halign: 'left' } }, '', '', reportLine.award_count]
                            let report_award_points = [{ content: 'AWARD POINTS', styles: { halign: 'left' } }, '', '', reportLine.award_points]

                                let report_first_trans_no = [{content:'FIRST TRAN NO', styles: { halign: 'left'}}, '', '',  reportLine.first_txn_no]
                                let report_last_trans_no = [{content:'LAST TRAN NO', styles: { halign: 'left'}}, '', '',  reportLine.last_txn_no]
                                let report_first_invoice_no = [{content:'FIRST INV NO', styles: { halign: 'left'}}, '', '',  reportLine.first_invoice_no]
                                let report_last_invoice_no = [{content:'LAST INV NO', styles: { halign: 'left'}}, '', '',  reportLine.last_invoice_no]
                                let report_invoice_total = [{content:'INVOICE TOTAL', styles: { halign: 'left'}}, '', '',  reportLine.invoice_total]
                                let report_z_counter = [{content:'Z-READING COUNTER', styles: { halign: 'left'}}, '', '',  reportLine.z_reading_counter]
                                let report_prev_sales = [{content:'OLD SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.previous_sales))]
                                let report_new_sales = [{content:'NEW SALES', styles: { halign: 'left'}}, '', '',  this.convertToCurrency(Number(reportLine.new_sales))]

                            // additional columns #5125
                            let report_cancelled = [{ content: 'CANCELLED', styles: { halign: 'left' } }, '', reportLine.cancelled_tran, this.convertToCurrency(Number(reportLine.cancelled_total))];
                            let report_cancelled_item = [{ content: 'CANCELLED ITEM', styles: { halign: 'left' } }, '', reportLine.cancelled_item, ''];
                            let report_refund = [{ content: 'REFUND', styles: { halign: 'left' } }, '', reportLine.refund_tran, this.convertToCurrency(Number(reportLine.refund_total))];
                            let report_refund_item = [{ content: 'REFUND ITEM', styles: { halign: 'left' } }, '', reportLine.refund_item, ''];
                            let report_open_checks = [{ content: 'OPEN CHECKS', styles: { halign: 'left' } }, '', reportLine.open_check_count, this.convertToCurrency(Number(reportLine.open_check_total))];
                            let report_total_cash = [{ content: 'TOTAL CASH', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.total_cash))]
                            let report_total_cash_dep = [{ content: 'TOTAL CASH DEPOSIT', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.total_deposit))]
                            let report_total_cash_wdl = [{ content: 'TOTAL CASH WITHDRAWAL', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.total_withdrawal))]
                            let report_total_cash_over_short = [{ content: 'TOTAL OVER/SHORT', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.total_over_short))]
                            let report_avg_txn = [{ content: 'AVERAGE PER TRANSACTION', styles: { halign: 'left' } }, '', '', this.convertToCurrency(Number(reportLine.avg_per_txn))]
                            let report_payment_label = [{ content: 'TENDER TOTALS', styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            let report_discount_label = [{ content: 'DISCOUNTS', styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            let report_discount_regular = [{ content: 'REGULAR', styles: { halign: 'left' } }, '', reportLine.discount_reg_count, this.convertToCurrency(Number(reportLine.discount_reg_total))];
                            let report_discount_sc = [{ content: 'SC', styles: { halign: 'left' } }, '', reportLine.discount_sc_count, this.convertToCurrency(Number(reportLine.discount_sc_total))];
                            let report_discount_pwd = [{ content: 'PWD', styles: { halign: 'left' } }, '', reportLine.discount_pwd_count, this.convertToCurrency(Number(reportLine.discount_pwd_total))];
                            let report_discount_pnstm = [{ content: 'PNSTM', styles: { halign: 'left' } }, '', reportLine.discount_pnstm_count, this.convertToCurrency(Number(reportLine.discount_pnstm_total))];
                            let report_discount_supercard = [{ content: 'SUPERCARD', styles: { halign: 'left' } }, '', reportLine.discount_supercard_count, this.convertToCurrency(Number(reportLine.discount_supercard_total))];

                            let sub_end_line = [{ content: `Site Name: ${reportLine.site_name}`, styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            let end_line = []
                            if (this.inputTerminal == 0) {
                                end_line = [{ content: `Terminal Name: All Terminals`, styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            } else {
                                end_line = [{ content: `Terminal Name: ${reportLine.terminal_name}`, styles: { fontStyle: 'bold', halign: 'left' } }, '', '', '']
                            }

                            // REPORT DATE
                            reportData.push(report_date_from)
                            reportData.push(report_date_to)

                            // // RUNNING TOTALS TO DATE
                            reportData.push(Object.assign({}, ["rowLine"]))
                            reportData.push(report_running_totals_to_date)
                            reportData.push(Object.assign({}, ["rowLine"]))

                            reportData.push(report_from_live_gross)
                            reportData.push(report_from_live_less_discount)
                            reportData.push(report_from_live_vat_exempt)
                            reportData.push(report_from_live_gross_less_discount)
                            reportData.push(report_from_live_net)
                            reportData.push(report_from_live_vat)

                            //  TOTALS 
                            reportData.push(Object.assign({}, ["rowLine"]))
                            reportData.push(report_totals)
                            reportData.push(Object.assign({}, ["rowLine"]))

                            reportData.push(report_gross)
                            reportData.push(report_less_discount)
                            reportData.push(report_vat_exempt)
                            reportData.push(report_gross_less_discount)
                            reportData.push(report_net)

                            reportData.push(report_vat)
                            reportData.push(report_vatable_sales)
                            reportData.push(report_non_vatable_sales)


                            reportData.push(report_count_amount)

                            reportData = reportData.concat(report_trans_types);

                            reportData.push(report_aggregator_beverage)
                            reportData.push(report_aggregator_food)

                            reportData.push(report_cancelled)
                            reportData.push(report_cancelled_item)
                            reportData.push(report_refund)
                            reportData.push(report_refund_item)
                            reportData = reportData.concat(report_reason_types);
                            reportData.push(report_trans_count)
                            reportData.push(report_guest_count)
                            reportData.push(report_avg_txn)
                            reportData.push(report_open_checks)



                            reportData.push(report_count_amount)

                            // payment_types
                            reportData.push(report_payment_label);
                            reportData = reportData.concat(report_payments);
                            reportData.push(Object.assign({}))

                            // discounts
                            reportData.push(report_discount_label);
                            reportData.push(report_discount_regular);
                            reportData.push(report_discount_sc);
                            reportData.push(report_discount_pwd);
                            reportData.push(report_discount_pnstm);
                            reportData.push(report_discount_supercard);
                            reportData.push(Object.assign({}))

                            // collections
                            if (isCollectionPresent) {
                                // reportData.push(report_space)
                                reportData.push(report_collection_label)
                                reportData = reportData.concat(report_collections);
                            }
                            reportData = reportData.concat(report_collections);

                            reportData.push(Object.assign({}))

                            // loyalty points
                            reportData.push(report_award_count)
                            reportData.push(report_award_points)

                                reportData.push(report_first_trans_no)
                                reportData.push(report_last_trans_no)
                                reportData.push(report_first_invoice_no)
                                reportData.push(report_last_invoice_no)
                                reportData.push(report_invoice_total)
                                reportData.push(report_z_counter)
                                reportData.push(report_prev_sales)
                                reportData.push(report_new_sales)

                            reportData.push(report_total_cash)
                            reportData.push(report_total_cash_dep)
                            reportData.push(report_total_cash_wdl)
                            reportData.push(report_total_cash_over_short)

                            reportData.push(Object.assign({}))
                            reportData.push(sub_end_line)
                            reportData.push(end_line)

                            if (i == this.birSalesReports.length - 1) {

                                //create table
                                design_y = design_y + 5
                                doc.autoTable({
                                    startY: design_y,
                                    head: [header],
                                    body: reportData,
                                    theme: 'plain',
                                    tableWidth: 'wrap',
                                    headStyles: {
                                        lineWidth: 0.15
                                    },
                                    showHead: 'never',
                                    styles: {
                                        cellPadding: 1.0,
                                        fontSize: 9,
                                        halign: 'right'
                                    },
                                    columnStyles: detailColStyles,
                                    didParseCell: function (data) {
                                        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine') {
                                            data.cell.styles.fillColor = [0, 0, 0]
                                            data.cell.styles.fontSize = 0.6
                                            data.cell.styles.cellPadding = 0
                                        } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :') {
                                            data.cell.styles.fontStyle = 'bold'
                                        }
                                    },

                                });
                            }
                        }
                    }
                }

                let printed_by = secureStorage.getItem("email")
                if (printed_by == null) {
                    printed_by = ''
                }

                let pageCount = doc.internal.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(9)
                    // doc.text(330, 490,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    reportUtils.pdfTools.addFooter(doc, printed_by, "Financial Report", 330, 487, i, pageCount)
                }
                window.open(URL.createObjectURL(doc.output("blob")))
            } else {
                this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
            }
            this.spinning = false;
        },
        generateFile: async function () {
            this.spinning = true;

            let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
            let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
            let report_from_date = this.inputDate[0].format('YYYY-MM-DD');
            let report_to_date = this.inputDate[1].format('YYYY-MM-DD');


            var get_request = await HTTPRequest.getRequest(this.endPoint + 'financial_reports?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&terminal_id=' + this.inputTerminal, null, "BXI-File");

            if (get_request.error) {
                reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                return
            }

            if (this.inputDate.length == 0) {
                this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                return
            }

            var siteSpecific = get_request;
            if (siteSpecific.length > 0) {

                if (siteSpecific[0].report_details[0].site_name == null) {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning = false;
                    return
                }

                let headers = [];
                let site_specific = [];

                for (var x = 0; x < siteSpecific.length; x++) {

                    this.birSalesReports = siteSpecific[x].report_details

                    headers = ['a', 'b', 'c', 'd', 'e']
                    let reportData = []
                    if (this.birSalesReports.length > 0) {

                        let grouper = 'start'

                        for (let i = 0; i < this.birSalesReports.length; i++) {
                            let reportLine = this.birSalesReports[i]
                            // body
                            // labels
                            let report_separator = ['-------------------------------------------------', '', '', '', '']
                            let report_separator_end = ['', '', '---------------------------', '--------------']
                            let report_running_totals_to_date = ["RUNNING TOTALS TO DATE", '', '', '', '']
                            let report_totals = ["REPORT TOTALS", '', '', '', '']
                            let report_date_from = ['Report Date: ', `${report_from_date}`, '', '', '']
                            let report_date_to = ['', `${report_to_date}`, '', '', '']

                            // details for running totals from live to date 
                            let report_from_live_gross = ['GROSS', '', '', '', this.convertToCurrency(Number(reportLine.running_gross))]
                            let report_from_live_less_discount = ['LESS DISCOUNT', '', '', '', this.convertToCurrency(Number(reportLine.running_less_discount))]
                            let report_from_live_vat_exempt = ['12% VAT-EXEMPT', '', '', '', this.convertToCurrency(Number(reportLine.running_vat_exempt))]
                            let report_from_live_gross_less_discount = ['GROSS LESS DEDUCTIONS', '', '', '', this.convertToCurrency(Number(reportLine.running_gross_less_discount))]
                            let report_from_live_net = ['NET', '', '', '', this.convertToCurrency(Number(reportLine.running_net))]
                            let report_from_live_vat = ['12% VAT', '', '', '', this.convertToCurrency(Number(reportLine.running_vat))]

                                // details for report totals
                                let report_gross = ['GROSS', '', '', '', this.convertToCurrency(Number(reportLine.report_gross))]
                                let report_less_discount = ['LESS DISCOUNT', '', '','',  this.convertToCurrency(Number(reportLine.report_less_discount))]
                                let report_gross_less_discount = ['GROSS LESS DEDUCTIONS', '', '','',  this.convertToCurrency(Number(reportLine.report_gross_less_discount))]
                                let report_net = ['NET', '', '', '', this.convertToCurrency(Number(reportLine.report_net))]
                                let report_vat = ['12% VAT', '', '', '', this.convertToCurrency(Number(reportLine.report_vat))]
                                let report_vatable_sales = ['NET VATABLE SALES', '', '','',  this.convertToCurrency(Number(reportLine.report_vatable_sales))]
                                let report_non_vatable_sales = ['NET VAT-EXEMPT SALES', '', '','',  this.convertToCurrency(Number(reportLine.report_vat_exempt_sales))]
                                let report_vat_exempt = ['12% VAT-EXEMPT', '', '','',  this.convertToCurrency(Number(reportLine.report_vat_exempt))]

                            let report_count_amount = ['', '', "COUNT", '', "AMOUNT"]
                            let report_collection_label = ["COLLECTIONS", '', '', '', '']
                            let report_space = ['', '', '', '', '']

                            // details for segment/pos transaction types
                            let report_trans_types = [];
                            let report_sub_segments = [];
                            for (let t = 0; t < this.transactionTypes.length; t++) {
                                let trans_type = this.transactionTypes[t];
                                let trans_type_count = `${trans_type.sanitized_name}_count`;
                                let trans_type_amount = `${trans_type.sanitized_name}_amount`;

                                let currentReport = reportLine;
                                if (currentReport[trans_type_count] != null) {
                                    let report_trans_type = [`${trans_type.name}`, '', currentReport[trans_type_count], '', this.convertToCurrency(Number(currentReport[trans_type_amount]))]
                                    report_trans_types.push(report_trans_type);

                                    // ADD SUBSEGMENT BREAKDOWN ON TRANSACTION TYPES
                                    for (let s = 0; s < this.subSegments.length; s++) {
                                        let sub_segment = this.subSegments[s];
                                        let sub_segment_count = `${sub_segment.sanitized_name}_count`;
                                        let sub_segment_amount = `${sub_segment.sanitized_name}_amount`;

                                        // let no_sub_segment = this.transactionTypes[t];
                                        // let no_sub_segment_count = `no_${no_sub_segment.sanitized_name}_count`;
                                        // let no_sub_segment_amount = `no_${no_sub_segment.sanitized_name}_amount`;

                                        let currentReport = reportLine;
                                        if (currentReport[sub_segment_count] != null && currentReport[sub_segment_count] != '0') {
                                            let report_sub_segment = [`  - ${sub_segment.name}`, '', currentReport[sub_segment_count], '', this.convertToCurrency(Number(currentReport[sub_segment_amount]))]
                                            if (this.subSegments[s].pos_trans_id == this.transactionTypes[t].id) {
                                                report_trans_types.push(report_sub_segment)
                                            }
                                        }

                                        // add trans_type with no sub-segment 
                                        //  if(currentReport[sub_segment_count] != null && currentReport[sub_segment_count] != '0'){
                                        //     let no_report_sub_segment = ['  - NO SUB SEGMENT', '', currentReport[no_sub_segment_count], '', this.convertToCurrency(Number(currentReport[no_sub_segment_amount]))]
                                        //     // add trans_type with no sub-segment once
                                        //     if(s == this.subSegments.length - 1){  
                                        //         report_trans_types.push(no_report_sub_segment)   
                                        //     }   
                                        // }
                                    } //end for(let  s = 0;  s < this.subSegments.length; s++) {
                                }
                            }

                            let report_aggregator_beverage = ['BEVERAGE', '', '', '', this.convertToCurrency(Number(reportLine.beverage))]
                            let report_aggregator_food = ['FOOD', '', '', '', this.convertToCurrency(Number(reportLine.food))]


                            // REASON TYPES (e.g. ON US)
                            let report_reason_types = [];
                            for (let rt = 0; rt < this.reasonTypesWithFinancial.length; rt++) {
                                let reason_type = this.reasonTypesWithFinancial[rt];
                                let rt_count = `rt_${reason_type.sanitized_name}_count`;
                                let rt_amount = `rt_${reason_type.sanitized_name}_amount`;

                                let currentReport = reportLine;
                                if (currentReport[rt_count] != null) {
                                    if (currentReport[rt_count] != 0.0 || currentReport[rt_amount] != 0) {
                                        let report_reason_type = [`${reason_type.name}`, '', currentReport[rt_count], '', this.convertToCurrency(Number(currentReport[rt_amount]))]
                                        report_reason_types.push(report_reason_type);
                                    }
                                }
                            } //end for(let rt = 0; rt < this.reasonTypesWithFinancial.length; rt++){

                            let report_trans_count = ['TRANSACTION COUNT', '', reportLine.transaction_count, '', '']
                            let report_guest_count = ['GUEST COUNT', '', reportLine.guest_count, '', '']

                            // payment_types
                            let report_payments = [];
                            for (let p = 0; p < this.payment_types.length; p++) {
                                let payment_type = this.payment_types[p];
                                let payment_type_count = `${payment_type.sanitized_name}_count`;
                                let payment_type_amount = `${payment_type.sanitized_name}_amount`;

                                let currentReport = reportLine;

                                // Create a report for the current payment type
                                if (currentReport[payment_type_count] != null) {
                                    if (currentReport[payment_type_amount] != 0.0 || currentReport[payment_type_count] != 0) {
                                        // FOR POS ONLY
                                        // if((payment_type.name == 'CASH') && (currentReport.cash_collection != null)){
                                        //     currentReport[payment_type_amount] = Number(currentReport[payment_type_amount]) + Number(currentReport.cash_collection)
                                        // }
                                        let report_payment = [`${payment_type.name}`, '', currentReport[payment_type_count], '', this.convertToCurrency(Number(currentReport[payment_type_amount]))]
                                        // Push the report into the accumulator array
                                        report_payments.push(report_payment);
                                    }
                                }

                            }

                            // collections
                            let report_collections = [];
                            let isCollectionPresent = false
                            for (let p = 0; p < this.collectionTypes.length; p++) {
                                let collection_type = this.collectionTypes[p];
                                let collection_type_count = `${collection_type.sanitized_name}_count`;
                                let collection_type_amount = `${collection_type.sanitized_name}_amount`;

                                let currentReport = reportLine;

                                // Create a report for the current collection type
                                if (currentReport[collection_type_amount] != 0.0 || currentReport[collection_type_count] != 0) {
                                    isCollectionPresent = true;
                                    let report_collection = [`${collection_type.name}`, '', currentReport[collection_type_count], '', this.convertToCurrency(Number(currentReport[collection_type_amount]))]
                                    // Push the report into the accumulator array
                                    report_collections.push(report_collection);
                                } else {
                                    isCollectionPresent = false;
                                }
                            }

                            // EGC
                            let report_egc = []
                            if (reportLine.egc_count != 0 || reportLine.egc_amount != 0.0) {
                                report_egc = ['EGC', '', reportLine.egc_count, '', reportLine.egc_amount]
                            }

                            // loyalty points
                            let report_award_count = ['AWARD COUNT', '', '', '', reportLine.award_count]
                            let report_award_points = ['AWARD POINTS', '', '', '', reportLine.award_points]

                                let report_first_trans_no = ['FIRST TRAN NO', '', '','',  reportLine.first_txn_no]
                                let report_last_trans_no = ['LAST TRAN NO', '', '','',  reportLine.last_txn_no]
                                let report_first_invoice_no = ['FIRST INV NO', '', '','',  reportLine.first_invoice_no]
                                let report_last_invoice_no = ['LAST INV NO', '', '','',  reportLine.last_invoice_no]
                                let report_invoice_total = ['INVOICE TOTAL', '', '','',  reportLine.invoice_total]
                                let report_z_counter = ['ZREADING COUNTER', '', '','',  reportLine.z_reading_counter]
                                let report_prev_sales = ['OLD SALES', '', '', '', this.convertToCurrency(Number(reportLine.previous_sales))]
                                let report_new_sales = ['NEW SALES', '', '','',  this.convertToCurrency(Number(reportLine.new_sales))]


                            // ADDITIONAL FIELDS #5125
                            let report_refund = ['REFUND', '', '', reportLine.refund_tran, this.convertToCurrency(Number(reportLine.refund_total))]
                            let report_refund_item = ['REFUND ITEM', '', '', reportLine.refund_item, '']
                            let report_cancelled = ['CANCELLED', '', '', reportLine.cancelled_tran, this.convertToCurrency(Number(reportLine.cancelled_total))]
                            let report_cancelled_item = ['CANCELLED ITEM', '', '', reportLine.cancelled_item, '']
                            let report_open_checks = ['OPEN CHECKS', '', '', reportLine.open_check_count, this.convertToCurrency(Number(reportLine.open_check_total))]
                            let report_total_cash = ['TOTAL CASH', '', '', '', this.convertToCurrency(Number(reportLine.total_cash))]
                            let report_total_cash_dep = ['TOTAL CASH DEPOSIT', '', '', '', this.convertToCurrency(Number(reportLine.total_deposit))]
                            let report_total_cash_wdl = ['TOTAL CASH WITHDRAWAL', '', '', '', this.convertToCurrency(Number(reportLine.total_withdrawal))]
                            let report_total_cash_over_short = ['TOTAL OVER/SHORT', '', '', '', this.convertToCurrency(Number(reportLine.total_over_short))]
                            let report_avg_txn = ['AVERAGE PER TRANSACTION', '', '', '', this.convertToCurrency(Number(reportLine.avg_per_txn))]
                            let report_payment_label = ['TENDER TOTALS', '', '', '', '']
                            let report_discount_label = ['DISCOUNTS', '', '', '', '']
                            let report_discount_regular = ['REGULAR', '', '', reportLine.discount_reg_count, this.convertToCurrency(Number(reportLine.discount_reg_total))]
                            let report_discount_sc = ['SC', '', '', reportLine.discount_sc_count, this.convertToCurrency(Number(reportLine.discount_sc_total))]
                            let report_discount_pwd = ['PWD', '', '', reportLine.discount_pwd_count, this.convertToCurrency(Number(reportLine.discount_pwd_total))]
                            let report_discount_pnstm = ['PNSTM', '', '', reportLine.discount_pnstm_count, this.convertToCurrency(Number(reportLine.discount_pnstm_total))]
                            let report_discount_supercard = ['SUPERCARD', '', '', reportLine.discount_supercard_count, this.convertToCurrency(Number(reportLine.discount_supercard_total))]


                            let sub_end_line = [`Site Name: ${reportLine.site_name}`, '', '', '', '']
                            let end_line = []
                            if (this.inputTerminal == 0) {
                                end_line = [`Terminal Name: All Terminals`, '', '', '', '']
                            } else {
                                end_line = [`Terminal Name: ${reportLine.terminal_name}`, '', '', '', '']
                            }


                            // REPORT DATE
                            reportData.push(report_date_from)
                            reportData.push(report_date_to)

                            // // RUNNING TOTALS TO DATE
                            reportData.push(report_separator)
                            reportData.push(report_running_totals_to_date)
                            reportData.push(report_separator)

                            reportData.push(report_from_live_gross)
                            reportData.push(report_from_live_less_discount)
                            reportData.push(report_from_live_vat_exempt)
                            reportData.push(report_from_live_gross_less_discount)
                            reportData.push(report_from_live_net)
                            reportData.push(report_from_live_vat)


                            //  TOTALS 
                            reportData.push(report_separator)
                            reportData.push(report_totals)
                            reportData.push(report_separator)

                            reportData.push(report_gross)
                            reportData.push(report_less_discount)
                            reportData.push(report_vat_exempt)
                            reportData.push(report_gross_less_discount)
                            reportData.push(report_net)
                            reportData.push(report_vat)
                            reportData.push(report_vatable_sales)
                            reportData.push(report_non_vatable_sales)

                            reportData.push(report_count_amount)

                            reportData = reportData.concat(report_trans_types);

                            reportData.push(report_aggregator_beverage)
                            reportData.push(report_aggregator_food)

                            reportData.push(report_cancelled)
                            reportData.push(report_cancelled_item)
                            reportData.push(report_refund)
                            reportData.push(report_refund_item)
                            reportData = reportData.concat(report_reason_types);
                            reportData.push(report_trans_count)
                            reportData.push(report_guest_count)
                            reportData.push(report_avg_txn)
                            reportData.push(report_open_checks)



                            reportData.push(report_count_amount)



                            // payment_types
                            reportData.push(report_payment_label)
                            reportData = reportData.concat(report_payments);
                            reportData.push(['', '', '', '', ''])

                            // discounts
                            reportData.push(report_discount_label)
                            reportData.push(report_discount_regular)
                            reportData.push(report_discount_sc)
                            reportData.push(report_discount_pwd)
                            reportData.push(report_discount_pnstm)
                            reportData.push(report_discount_supercard)
                            reportData.push(['', '', '', '', ''])

                            // collections
                            if (isCollectionPresent) {
                                //  reportData.push(report_space)
                                reportData.push(report_collection_label)
                                reportData = reportData.concat(report_collections);
                            }
                            reportData.push(['', '', '', '', ''])
                            // loyalty points
                            reportData.push(report_award_count)
                            reportData.push(report_award_points)

                                reportData.push(report_first_trans_no)
                                reportData.push(report_last_trans_no)
                                reportData.push(report_first_invoice_no)
                                reportData.push(report_last_invoice_no)
                                reportData.push(report_invoice_total)
                                reportData.push(report_z_counter)
                                reportData.push(report_prev_sales)
                                reportData.push(report_new_sales)

                            reportData.push(report_total_cash)
                            reportData.push(report_total_cash_dep)
                            reportData.push(report_total_cash_wdl)
                            reportData.push(report_total_cash_over_short)

                            reportData.push(sub_end_line)
                            reportData.push(end_line)


                        }
                    }

                    let printed_by = secureStorage.getItem("email")
                    if (printed_by == null) {
                        printed_by = ''
                    }

                    reportData.push(['', '', '', '', ''])
                    reportData.push(["Financial Report", "Generated By: " + printed_by, "", "For the Period of " + report_from_date + " to " + report_to_date, ""])
                    reportData.push(['', '', '', '', ''])

                    this.JsonData = reportData;
                }

            } else {
                this.openNotificationWithIcon('error', 'No Data');
            }
            this.spinning = false;
        },
        clearJsonData() {
            this.JsonData = [];
        },
    }
};
</script>

<style></style>